import React, {createContext, ReactNode, useContext} from "react";

interface DrawerContextProviderProps {
    children: ReactNode;
    open: boolean;
    handleToggleDrawer: () => void;
}

export function useDrawerContext() {
    const context = useContext(DrawerContext);
    if (context === undefined) {
        throw new Error('useDrawerContext must be called within its Provider')
    }
    return context;
}

type DrawerContextProps = {
    open: boolean;
    handleToggleDrawer: () => void;
};

const DrawerContext = createContext({} as DrawerContextProps)

export default function DrawerContextProvider({open, handleToggleDrawer, children}: DrawerContextProviderProps) {

    return (<DrawerContext.Provider value={{open, handleToggleDrawer}}>
            {children}
        </DrawerContext.Provider>);

}